import { CaseByIdQuery, Maybe, UserType } from 'src/graphql';

export const getCaseTeamWithoutOldCaseLead = (
  oldData: CaseByIdQuery,
  existingCaseLead: Maybe<UserType> | undefined,
) =>
  oldData?.caseById?.CaseTeam?.filter(
    (caseTeamMember) => caseTeamMember.id !== existingCaseLead?.id,
  );
